import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { F } from "./Fields";

const FIELDS = [
  ["tiktok", "TikTok (también se usa en el botón En vivo)", "https://www.tiktok.com/@tu-usuario"],
  ["spotify", "Spotify", "https://open.spotify.com/artist/..."],
  ["soundcloud", "SoundCloud", "https://soundcloud.com/tu-usuario"],
  ["instagram", "Instagram", "https://instagram.com/tu-usuario"],
  ["youtube", "YouTube", "https://youtube.com/@tu-canal"],
  ["facebook", "Facebook", "https://facebook.com/tu-pagina"],
];

export const SocialForm = () => {
  const [v, setV] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setV(r.data?.socials ?? {})).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.put("/admin/settings", v);
      setV(r.data.socials);
      toast.success("Redes guardadas");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={save} className="grid sm:grid-cols-2 gap-5" data-testid="social-form">
      <p className="sm:col-span-2 text-sm text-[#A8B3C4]">Pega el enlace de cada red. Las que dejes vacías no se muestran en la portada.</p>
      {FIELDS.map(([k, label, ph]) => (
        <F key={k} label={label} placeholder={ph} value={v[k] || ""} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`social-input-${k}`} />
      ))}
      <div className="sm:col-span-2">
        <button data-testid="social-save-button" disabled={busy} className="flex items-center gap-2 px-6 py-3.5 bg-[#1FD1FF] text-black font-mono text-sm uppercase tracking-widest hover:bg-white transition-colors disabled:opacity-60">
          <Save className="w-4 h-4" />{busy ? "Guardando…" : "Guardar redes"}
        </button>
      </div>
    </form>
  );
};
